export const CONFIG_KEY = 'PLACEMENT';
export const SHOW_APPROVE_BUTTON_KEY = 'showApprove';
export const APPROVE_BUTTON_LABEL_KEY = 'approveWeekButtonLabel';
export const DEFAULT_APPROVE_BUTTON_LABEL = 'Approve All';
export const DATA_THROTTLE_TIMEOUT_KEY = 'throttleTimeout';
export const DEFAULT_DATA_THROTTLE_TIMEOUT = 60000;
